import React, { useState } from "react";
import classNames from "classnames";
import { FilterSourceItem, FilterValues } from "./FilterValuesCollection";
import productListAutocompleteService, { FilterKeyValuePair } from "./ProductListAutocompleteService";

interface ProductListBookAuthorFilterProperties {
    readonly isActive: boolean;
    readonly bookAuthors: FilterSourceItem[];
    readonly filter: FilterValues;

    readonly onFilterChange: (filter: FilterValues) => void;
    readonly onActivateTab: () => void;
}

export default function ProductListBookAuthorFilter({
    isActive,
    bookAuthors,
    filter,
    onFilterChange,
    onActivateTab,
}: ProductListBookAuthorFilterProperties): React.JSX.Element | undefined {
    const [autocompleteValue, setAutocompleteValue] = useState<string>("");
    const [currentBookAuthors, setCurrentBookAuthors] = useState<FilterKeyValuePair[]>(bookAuthors
        .map((bookAuthor) => ({
            id: bookAuthor.id,
            title: bookAuthor.title,
        })));

    if (bookAuthors.length === 0) {
        return undefined;
    }

    const handleFilterToggle = (authorId: number): void => {
        let currentAuthors: number[] = filter.BookAuthors ?? [];

        if (currentAuthors.includes(authorId)) {
            currentAuthors = currentAuthors.filter((id) => id !== authorId);
        } else {
            currentAuthors.push(authorId);
        }

        onFilterChange(Object.assign({}, filter, { BookAuthors: currentAuthors }));
    };

    const handleAutocompleteInput = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        const value = event.target.value.toLowerCase();
        setAutocompleteValue(value);

        if (value.trim() === "") {
            setCurrentBookAuthors(bookAuthors
                .map((bookAuthor) => ({
                    id: bookAuthor.id,
                    title: bookAuthor.title,
                })));

            return;
        }

        if (value.trim().length < 2) {
            return;
        }

        setCurrentBookAuthors(await productListAutocompleteService.getBookAuthorFilterValues(value));
    };

    return (
        <div className="filter-widget">
            <h2 className={isActive ? "active" : undefined} onClick={onActivateTab}>Autor<i className="fa-solid fa-caret-down"></i></h2>

            <div className={classNames("widget-content", "category-checkbox", { hidden: !isActive })}>
                <div className="widget-search">
                    <input
                        type="text"
                        placeholder="Zadejte jméno autora"
                        onChange={(event) => void handleAutocompleteInput(event)}
                        value={autocompleteValue} />
                    <i className="fa-solid fa-search"></i>
                </div>

                <div className="widget-inner">
                    {currentBookAuthors.map((bookAuthor) => <div className="filter-container" key={bookAuthor.id}>
                        <label htmlFor={`fa_${bookAuthor.id}`}>
                            {bookAuthor.title}
                            <input
                                type="checkbox"
                                id={`fa_${bookAuthor.id}`}
                                value={bookAuthor.id}
                                onChange={() => handleFilterToggle(bookAuthor.id)}
                                checked={filter.BookAuthors?.includes(bookAuthor.id)} />
                            <span className="checkmark"></span>
                            {bookAuthor.quantity !== undefined && <span> ({bookAuthor.quantity}&times;)</span>}
                        </label>
                    </div>)}
                </div>
            </div>
        </div>
    );
}
